import "./index.less";
import { setCookie, cookie }  from '@utils/index.js'
import { regoinlist } from '@utils/api.js';

// IP定位
$(document).ready(function () {
    if (!customElements.get('jky-locale-switcher')) { 
        customElements.define('jky-locale-switcher', class JkyAnnounmentBar extends HTMLElement {
            constructor() {
                super();
                let that = this
                this.selectors = {
                    // IP定位
                    locale_switcher: $(this).find('.locale-switcher'),
                    locale_switcher_text: $(this).find('.locale-switcher .locale-switcher--text'),
                    locale_switcher_val: $(this).find('.locale-switcher .locale-switcher--value .text'),
                    locale_switcher_btn: $(this).find('.locale-switcher .locale-switcher--button'),
                    locale_switcher_close: $(this).find(".locale-switcher .locale-switcher--close"),
                    locale_switcher_ul: $(this).find(".locale-switcher .locale-switcher--ul"),
                    locale_switcher_sel: $(this).find(".locale-switcher .locale-switcher--selected"),
                    locale_switcher_current: $(this).find(".locale-switcher .locale-switcher--selected .current"),
                }
                this.regoinList = window.regoinList

                // 异步加载非关键css资源
                loadCSS(pageInfo.__webpack_public_path__ + 'plugins-locale-switcher.min.css', () => {
                    that.classList.remove("hidden");
                });

                this.init()
            }

            // 初始化IP定位
            async initLocaleSwitcher() {
                const flag = window.localStorage.getItem("closeLocaleSwitcher");
                const localeCookie = cookie.get('_jk_locale_switcher')
                if (flag == 1 || localeCookie) {
                return false;
                }
                const params = {
                    // ip:
                }
                const { data } = await regoinlist(params);
                this.regoinList = data

                const { showFlag, regoinResps, currentIpRegoin } = this.regoinList
                if (!showFlag) return 
                
                // 处理数据
                this.selectors.locale_switcher_text.html(currentIpRegoin.showInfo)
                this.selectors.locale_switcher_val.html(currentIpRegoin.name).attr('value', currentIpRegoin.shopId)
                this.selectors.locale_switcher_btn.text(currentIpRegoin.showButton)
                this.selectors.locale_switcher.addClass('locale-switcher-show')
                
                // 初始化列表数据
                const filterData = regoinResps.filter(item => item.shopId !== currentIpRegoin.shopId)
                let html = `
                <i class="iconfont jackery-icon-arrowtop"></i>
                <li class="current"  data-url="${currentIpRegoin.domain}" value="${currentIpRegoin.shopId}">
                    <span>
                        <span class="icon"> <i class="iconfont jackery-icon-yes"></i></span> 
                        <span> ${currentIpRegoin.name}</span>
                    </span>
                    <span></span>    
                </li>
                `
                filterData.forEach((item) => {
                html += `
                        <li class="sel-li" data-url="${item.domain}" data-value="${item.shopId}">
                            <span>
                                <span class="icon"></span> 
                                <span class="text">${item.name}</span>
                            </span>
                            <span></span>
                        </li>
                        `;
                });

                this.selectors.locale_switcher_ul.html(html)
            }

            // 事件监听
            onLocaleSwitcher() {
                const that = this
                this.selectors.locale_switcher_sel.click(function() {
                that.selectors.locale_switcher_ul.addClass('show')
                })

                // 跳转点击
                this.selectors.locale_switcher_btn.click(function() {
                // 写到主域名里面
                setCookie('_jk_locale_switcher', 'true', 180, true)
                window.location.href = that.regoinList.currentIpRegoin.domain;
                })
                // PC ul移除
                this.selectors.locale_switcher_ul.mouseleave(function(){
                that.selectors.locale_switcher_ul.removeClass('show')
                })

                // MB UL移除
                $(document).click(function (e) {
                const localePop = $(".locale-switcher--ul");
                const arr = [
                    "local-switcher--selected",
                    "iconfont jackery-icon-arrowdown",
                    "iconfont jackery-icon-yes",
                    "text",
                ];
                const flag = arr.includes($(e.target).attr("class"));
                if (!localePop.is(e.target) && !flag) {
                    $(".locale-switcher--ul").removeClass("show");
                }
                });

                // li点击跳转
                this.selectors.locale_switcher_ul.on("click", "li", function (e) {
                const domin = $(this).attr("data-url");
                // 写到主域名里面
                setCookie('_jk_locale_switcher', 'true', 180, true)
                window.location.href = domin;
                });
            }

            closeLocaleSwitcher() { // IP定位关闭
                let that = this
                this.selectors.locale_switcher_close.click(function() {
                that.selectors.locale_switcher.slideToggle(250)
                window.localStorage.setItem("closeLocaleSwitcher", 1);
                })
            }

            init () {
                // 初始化IP定位
                this.initLocaleSwitcher()
                this.onLocaleSwitcher()
                this.closeLocaleSwitcher()
            }
        }) 
    }
})